<template>
  <div class="pass">
    <div>
      <van-nav-bar
        @click-left="navTo('/account')"
        @click-right="navTo('/')"
        fixed
        placeholder
        :title="$t('account.pass')"
      >
        <template #left>
          <van-icon color="#000" name="arrow-left" />
        </template>
        <template #right>
          <van-icon color="#000" name="wap-home-o" />
        </template>
      </van-nav-bar>
    </div>

    <div>
      <van-form>
        <van-field
          v-model="form.oldPassword"
          type="password"
          name="old password"
          label=""
          placeholder="old password"
          :rules="[
            { required: true, message: 'Please enter the old password' },
          ]"
        />
        <van-field
          v-model="form.newPassword"
          type="password"
          name="new password"
          label=""
          placeholder="new password"
          :rules="[
            { required: true, message: 'Please enter the new password' },
          ]"
        />
        <van-field
          v-model="confirmPassword"
          type="password"
          name="confirm password"
          label=""
          placeholder="confirm password"
          :rules="[{ required: true, message: 'Please confirm new password' }]"
        />
        <div style="margin: 16px">
          <van-button round block type="info" @click="updatePass" native-type=""
            >submit</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { updatePass } from "@/common/api/api";

export default {
  name: "pass",
  data() {
    return {
      form: {
        oldPassword: "",
        newPassword: "",
      },
      confirmPassword: "",
    };
  },
  created() {},
  methods: {
    navTo(path) {
      this.$router.push(path);
    },
    updatePass() {
      if (this.form.newPassword == this.confirmPassword) {
        const data = {
          oldPassword: this.form.oldPassword,
          newPassword: this.form.newPassword,
          userId: this.$store.getters.userInfo.userId,
        };
        updatePass(data).then((res) => {
          if (res.code == 200) {
            this.$toast.success({
              message: "success",
            });
            this.$dialog
              .confirm({
                message: "Please log in again",
              })
              .then(() => {
                this.$store.dispatch("logout").then((res) => {
                  this.navTo("/login");
                });
              });
          } else {
            this.$toast.fail({
              message: "fail",
            });
          }
        });
      }
    },
  },
};
</script>

<style></style>
